
class JsonApi {

    constructor() {
		//this.baseUrl = "https://pimcore-homeweb.dev.ateles.se";
		this.baseUrl = "https://www.glavichsandell.se";

    }

    get(path, successFunction, errorFunction) {
        fetch(this.baseUrl + path, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
				'Origin': 'pimcore-homeweb.dev.ateles.se',
                'apikey': 'b342189a48309f9f6bb9b294ee652d7c' //localStorage.getItem('apiToken')
            }
        })
            .then(response => {
                if (!response.ok) {
                    console.log("Network error");
                    return {status: 'error', message: 'Nätverksfel'};
                }
                return response.json()
            })
            .then(data => {
                    successFunction(data);
                },
                error => {
                    console.log("failing fetch");
                    console.log(error)
                    if (errorFunction != null) {
                        errorFunction(error);
                    }
                })
            .catch(error => {
            if (error instanceof TypeError && error.message.includes('API key')) {
                console.error('Invalid API key:', error);
            } else {
                console.error('There was a problem with the Fetch operation:', error);
            }
            errorFunction({status: 'error', message: 'Nätverksfel! (' + error.message + ')' });
        });

    }

    post(path, data, successFunction, errorFunction) {
        fetch(this.baseUrl + path + '?apikey=b342189a48309f9f6bb9b294ee652d7c', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
				'Origin': 'pimcore-homeweb.dev.ateles.se',
				'Sec-Fetch-Dest': 'empty',
				'Sec-Fetch-Mode': 'cors',
				'Sec-Fetch-Site': 'same-site',
                //'apikey':  'b342189a48309f9f6bb9b294ee652d7c'//'dd815fa5ed2e70be0213032369b48709'
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                    if (!response.ok) {
                        return {status: 'error', message: 'Network error'};
                    }
                    return response.json()
                }
            )
            .then(data => {
                    successFunction(data);
            })
            .catch(error => {
                if (error instanceof TypeError && error.message.includes('API key')) {
                    console.error('Invalid API key:', error);
                } else {
                    console.error('There was a problem with the Fetch operation:', error);
                }
                if (errorFunction != null) {
                    errorFunction({status: 'error', message: 'Nätverksfel! (' + error.message + ')' });
                }
            });


    }

}

export default JsonApi;
